{
  "name": "@primer/css",
  "version": "22.0.2",
  "description": "The CSS implementation of GitHub's Primer Design System",
  "homepage": "https://primer.style/css",
  "author": "GitHub, Inc.",
  "engines": {
    "node": ">=16.0.0"
  },
  "license": "MIT",
  "style": "dist/primer.css",
  "sass": "index.scss",
  "type": "module",
  "main": "dist/primer.js",
  "repository": "https://github.com/primer/css",
  "bugs": {
    "url": "https://github.com/primer/css/issues"
  },
  "keywords": [
    "primer",
    "css",
    "github",
    "design-system"
  ],
  "scripts": {
    "build:docs": "script/build-docs",
    "build:docs:preview": "script/build-docs preview",
    "build:css": "script/build-css.js",
    "dist": "script/dist.js",
    "dist:watch": "chokidar \"src/**/*.scss\" -c \"script/dist.js\"",
    "stylelint": "stylelint --quiet --rd 'src/**/*.scss'",
    "stylelint:fix": "npm run stylelint -- --fix",
    "stylelint:remove-disables": "script/stylelint-remove-disables.js 'src/**/*.scss'",
    "stylelint:add-disables": "script/stylelint-add-disables.js 'src/**/*.scss'",
    "eslint": "eslint deprecations.js __tests__ script",
    "prepublishOnly": "script/prepublish",
    "pretest": "npm run dist && script/pretest",
    "test": "NODE_OPTIONS=--experimental-vm-modules npx jest",
    "release": "changeset publish",
    "storybook": "cd docs && npm i && npx storybook build",
    "build:storybook": "cd docs && npm i && npm run build:storybook"
  },
  "devDependencies": {
    "@changesets/changelog-github": "^0.5.0",
    "@changesets/cli": "^2.27.12",
    "@csstools/postcss-sass": "^5.1.1",
    "@github/prettier-config": "^0.0.6",
    "@primer/primitives": "^11.3.1",
    "@primer/stylelint-config": "^13.2.3",
    "autoprefixer": "^10.4.18",
    "chokidar-cli": "^3.0.0",
    "cssstats": "^4.0.5",
    "eslint": "^9.18.0",
    "eslint-plugin-github": "^6.0.0",
    "eslint-plugin-jest": "^29.2.1",
    "eslint-plugin-prettier": "^5.2.3",
    "filesize": "^11.0.13",
    "front-matter": "^4.0.2",
    "fs-extra": "^11.3.0",
    "globby": "^16.0.0",
    "jest": "^29.5.0",
    "js-yaml": "^4.1.0",
    "postcss": "^8.5.1",
    "postcss-calc": "^10.1.0",
    "postcss-import": "^16.0.1",
    "postcss-load-config": "^6.0.1",
    "postcss-scss": "^4.0.5",
    "postcss-simple-vars": "^7.0.1",
    "prettier": "^3.4.2",
    "semver": "^7.6.0",
    "stylelint": "^16.10.0",
    "table": "^6.8.1",
    "tslib": "^2.8.1"
  },
  "peerDependencies": {
    "@primer/primitives": "10.x || 11.x"
  },
  "jest": {
    "testEnvironment": "node",
    "testPathIgnorePatterns": [
      "/node_modules/",
      "/__tests__/utils/",
      "/__tests__/docs.test.js"
    ],
    "transform": {}
  },
  "browserslist": [
    "last 10 Chrome versions",
    "last 4 Firefox versions",
    "last 3 Safari versions",
    "not Safari 12",
    "last 4 Edge versions",
    "not Edge <= 18",
    "Firefox ESR"
  ],
  "eslintConfig": {
    "extends": [
      "plugin:github/internal",
      "plugin:github/recommended"
    ],
    "env": {
      "es6": true,
      "node": true
    },
    "parserOptions": {
      "ecmaVersion": 2017,
      "requireConfigFile": false
    }
  }
}
